<button (click)="openConfig.emit()" class="config-panel-toggle" mat-fab type="button">
  <mat-icon>settings</mat-icon>
</button>
